const UUID_BYTES = 16;

function getRandomBytes(): Uint8Array {
  const bytes = new Uint8Array(UUID_BYTES);
  const cryptoApi = globalThis.crypto;

  if (typeof cryptoApi?.getRandomValues === 'function') {
    return cryptoApi.getRandomValues(bytes);
  }

  for (let index = 0; index < bytes.length; index += 1) {
    bytes[index] = Math.floor(Math.random() * 256);
  }

  return bytes;
}

/**
 * Creates an RFC 4122 UUID v4, including on older Android WebViews that do not
 * expose `crypto.randomUUID`.
 */
export function createUuid(): string {
  const cryptoApi = globalThis.crypto;

  if (typeof cryptoApi?.randomUUID === 'function') {
    return cryptoApi.randomUUID();
  }

  const bytes = getRandomBytes();
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'));
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`;
}
